// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".action-menu[data-v-2f0d428e]  .primary-action {\n  border: 0px !important;\n}\n.action-menu[data-v-2f0d428e]  .menu-activator {\n  border: 0px !important;\n}", ""]);
// Exports
module.exports = exports;
